import { HsVector3 } from '../../../math-new/objects/vector3.class';
import type { HsHypersceneTypes } from '../../../math-new/types/hyperscene-types.type';
import { HsLight } from './light.class';

export class HsPointLight extends HsLight {
  public radius: number = 1;
  public falloff: number = 1;

  private readonly position: HsVector3 = HsVector3.makeZeroVector();

  public getDynamicPosition(): HsHypersceneTypes.Array3 {
    this.position.setFromMatrixPosition(this.worldMatrix.values);
    return this.position.values;
  }
}
